<!--
 * @Author: maqian maqian@aeonmed.com
 * @Date: 2025-03-21 08:57:04
 * @LastEditors: maqian maqian@aeonmed.com
 * @LastEditTime: 2025-03-21 09:24:53
 * @FilePath: \shh-download\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,body{
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  font-size: 14px;
}
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue